import React, { useMemo, useState, useEffect } from 'react';
import {
  RACES, UNITS, STRUCTURES, unitsByRace, techChainForUnit, techChainTimeline, formatNum, formatTime,
} from './sc2Data';

function BuildChain({ raceId }) {
  const race = RACES[raceId];
  const units = useMemo(() => unitsByRace(raceId), [raceId]);
  const [unitId, setUnitId] = useState(units[1]?.id || units[0].id);

  useEffect(() => {
    const list = unitsByRace(raceId);
    setUnitId(list[1]?.id || list[0].id);
  }, [raceId]);

  const unit = UNITS[unitId];
  const chain = techChainForUnit(unitId);
  const timeline = techChainTimeline(unitId);
  const totalTech = timeline.length ? Math.max(...timeline.map((t) => t.finish)) : 0;

  const chainCost = chain.reduce(
    (acc, id) => ({ minerals: acc.minerals + STRUCTURES[id].minerals, gas: acc.gas + STRUCTURES[id].gas }),
    { minerals: 0, gas: 0 }
  );

  const firstUnitAt = totalTech + unit.time;

  return (
    <div>
      <h2 className="sc2-section-title" style={{ color: race.color }}>
        {race.icon} Цепочка постройки: {race.ru}
      </h2>

      <div className="sc2-panel">
        <label className="sc2-chain-select-label">
          Какой юнит хотите получить?{' '}
          <select value={unitId} onChange={(e) => setUnitId(e.target.value)}>
            {units.map((u) => <option key={u.id} value={u.id}>{u.ru} ({u.name})</option>)}
          </select>
        </label>

        <div className="sc2-chain-flow">
          {timeline.map((step, i) => {
            const s = STRUCTURES[step.id];
            return (
              <React.Fragment key={step.id}>
                {i > 0 && <div className="sc2-flow-arrow">→</div>}
                <div className="sc2-flow-node" style={{ borderColor: race.color }}>
                  <div className="sc2-flow-name">{s.ru}</div>
                  <div className="sc2-flow-cost">
                    💎 {s.minerals}{s.gas > 0 ? ` · 🟢 ${s.gas}` : ''}
                  </div>
                  <div className="sc2-flow-time">⏱ {s.time}с {s.morphFrom ? `(морф из «${STRUCTURES[s.morphFrom].ru}»)` : ''}</div>
                  <div className="sc2-flow-finish">готово к {formatTime(step.finish)}</div>
                </div>
              </React.Fragment>
            );
          })}
          <div className="sc2-flow-arrow">→</div>
          <div className="sc2-flow-node unit" style={{ borderColor: '#28a745' }}>
            <div className="sc2-flow-name">{unit.ru}</div>
            <div className="sc2-flow-cost">💎 {unit.minerals}{unit.gas > 0 ? ` · 🟢 ${unit.gas}` : ''} · 👥 {unit.supply}</div>
            <div className="sc2-flow-time">⏱ {unit.time}с{unit.morphOf ? ` (морф из «${UNITS[unit.morphOf].ru}»)` : ''}</div>
            <div className="sc2-flow-finish">первый юнит к ~{formatTime(firstUnitAt)}</div>
          </div>
        </div>

        <div className="sc2-chain-summary">
          <div className="sc2-chain-summary-item">
            <div className="sc2-chain-summary-value">💎 {formatNum(chainCost.minerals)} · 🟢 {formatNum(chainCost.gas)}</div>
            <div className="sc2-chain-summary-label">стоимость всей цепочки технологий</div>
          </div>
          <div className="sc2-chain-summary-item">
            <div className="sc2-chain-summary-value">{formatTime(totalTech)}</div>
            <div className="sc2-chain-summary-label">минимальное время постройки цепочки (последовательно)</div>
          </div>
          <div className="sc2-chain-summary-item">
            <div className="sc2-chain-summary-value">~{formatTime(firstUnitAt)}</div>
            <div className="sc2-chain-summary-label">первый {unit.ru} (без учёта накопления ресурсов)</div>
          </div>
        </div>

        <p className="sc2-note">
          Время считается по зависимостям: независимые здания можно строить параллельно, если хватает ресурсов и рабочих.
          Реальный тайминг будет чуть позже — нужно ещё накопить минералы и газ.
          {raceId === 'zerg' && ' У зергов здания строятся из дрона (дрон тратится).' }
          {raceId === 'protoss' && ' Все здания протоссов требуют питания от пилона.'}
          {unit.techLab ? ' Юнит требует лабораторию на здании (+50/25, 18с).' : ''}
        </p>
      </div>
    </div>
  );
}

export default BuildChain;
